import { useCallback, useContext, useEffect, useState } from 'react';
import './pane-left-task-counter.scss';
import { TasksCounterContext } from '../context/tasks-counter-context';
import { RecipientContext } from '../context/recipient-context';
import { Popover } from 'devextreme-react/popover';

const TaskCounter = () => {

    // Complete = 0,
    // New = 1,
    // Overdue = 2,
    // Future = 3,
    // Uncomplete = 4,
    // Execute = 5,
    // RedPriority = 6,
    // YellowPriority = 7,
    // GreenPriority = 8,
    // WithoutPriority = 9,

    const [counter, setCounter] = useContext(TasksCounterContext);
    const [recipient, setRecipient] = useContext(RecipientContext);
    const [localTasksCounter, setLocalTasksCounter] = useState(counter);

    const handleTaskClick = useCallback(() => {
        setRecipient(null);
    }, []);


    // Update localTasksCounter whenever tasksCounter changes
    useEffect(() => {
        setLocalTasksCounter(counter);
    }, [counter]);


    const renderContent = () => {
        return (
            <span>{localTasksCounter && localTasksCounter[1] && localTasksCounter[1].length ? "Нові завдання: " + localTasksCounter[1].length : "Немає нових завдань"}</span>
        );
    };


    return (
        <>
            <div className={!recipient ? "task-item-container-selected" : "task-item-container"} onClick={handleTaskClick}>
                <div className="task-item-counter" >
                    <span style={{ color: recipient && localTasksCounter && localTasksCounter[1] && localTasksCounter[1].length ? "red" : "#193266"  }}>{localTasksCounter && localTasksCounter[1] ? localTasksCounter[1].length : 0}</span>
                </div>
                <span style={{ marginLeft: '8px' }}>Завдання</span>
            </div>

            <Popover
                target=".task-item-counter"
                showEvent="dxhoverstart"
                hideEvent="dxhoverend"
                contentRender={renderContent}
            />
        </>
    );
};

export default TaskCounter;



